module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "auth--background"
  }, [_c('div', {
    staticClass: "auth--inner"
  }, [(!_vm.added) ? [_c('h3', [_vm._v("Adding your team to Worklogs")]), _vm._v(" "), _c('div', {
    staticClass: "slack-loader"
  })] : [_c('h3', [_vm._v("Your team has been added")]), _vm._v(" "), _c('a', {
    staticClass: "kuzco-green button is-primary",
    attrs: {
      "href": "https://slack.com/oauth/authorize?scope=identity.email,identity.basic,identity.team&client_id=144664336758.147194983298&redirect_uri=https%3A%2F%2Fworklogs.co%2F%23%2Fslackauth&state=2a745b37"
    }
  }, [_vm._v("Sign in with Slack")])]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1124fb2e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SlackAdd.vue
// module id = 380
// module chunks = 1